'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldConnect = shouldConnect;
function _buildConnectionInfo(_ref) {
  var service = _ref.service,
    _resource = _ref.resource,
    domain = _ref.domain,
    username = _ref.username,
    password = _ref.password;
  process.env.NODE_ENV === 'development' && console.log('CHAT | JAIMINHO | CONSTRUCTOR', _resource);
  var separator = service.indexOf('?') === -1 ? '?' : '&';
  return {
    service: '' + service + separator + 'origin=' + _resource,
    domain: domain,
    resource: function resource(binder) {
      return binder(_resource + '-' + new Date().getTime());
    },
    platform: _resource,
    username: username,
    password: password
  };
}
exports._buildConnectionInfo = _buildConnectionInfo;
function shouldConnect(connectionInfo) {
  var platform = connectionInfo.platform,
    password = connectionInfo.password;
  var isApp = ['ios', 'android'].indexOf(platform) > -1;
  return !(isApp && !password);
}